/* tslint:disable */
/* eslint-disable */
/**
 * Intranet - Boilerplate API
 * You need to change all the object names to your project ones
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddressSearchResponseResponse } from '../models';
// @ts-ignore
import type { BooleanResponse } from '../models';
// @ts-ignore
import type { CorporateEntityInvoiceConfigurationDTOListResponse } from '../models';
// @ts-ignore
import type { CorporateEntityInvoiceConfigurationDTOResponse } from '../models';
// @ts-ignore
import type { CorporateEntityResponse } from '../models';
// @ts-ignore
import type { CorporateEntitySearchResponseResponse } from '../models';
// @ts-ignore
import type { CreateAccountPayableInvoice } from '../models';
// @ts-ignore
import type { CreateCorporateEntityCommand } from '../models';
// @ts-ignore
import type { CreateInvoiceCommand } from '../models';
// @ts-ignore
import type { CreateInvoiceConfigurationCommand } from '../models';
// @ts-ignore
import type { CreatePersonaCommand } from '../models';
// @ts-ignore
import type { CreateTaxRateCommand } from '../models';
// @ts-ignore
import type { CurrencyResponse } from '../models';
// @ts-ignore
import type { CurrencySearchResponseResponse } from '../models';
// @ts-ignore
import type { IncomingInvoiceDTOSearchResponseResponse } from '../models';
// @ts-ignore
import type { InvoiceResponse } from '../models';
// @ts-ignore
import type { InvoiceSearchResponseResponse } from '../models';
// @ts-ignore
import type { InvoiceTypeSearchResponseResponse } from '../models';
// @ts-ignore
import type { ListOptionDTOSearchResponseResponse } from '../models';
// @ts-ignore
import type { PersonaResponse } from '../models';
// @ts-ignore
import type { PersonaSearchResponseResponse } from '../models';
// @ts-ignore
import type { StatusCodeResult } from '../models';
// @ts-ignore
import type { StringResponse } from '../models';
// @ts-ignore
import type { StringStringDictionaryResponse } from '../models';
// @ts-ignore
import type { TaxRateResponse } from '../models';
// @ts-ignore
import type { TaxRateSearchResponse } from '../models';
// @ts-ignore
import type { UpdateCorporateEntityCommand } from '../models';
// @ts-ignore
import type { UpdateInvoiceCommand } from '../models';
// @ts-ignore
import type { UpdateInvoiceConfigurationCommand } from '../models';
// @ts-ignore
import type { UpdatePersonaCommand } from '../models';
// @ts-ignore
import type { UpdateTaxRateCommand } from '../models';
/**
 * InvoiceApi - axios parameter creator
 * @export
 */
export const InvoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets a list of all corporate entities
         * @param {string} version 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionCorporateEntityAllGet: async (version: string, pageNum?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionCorporateEntityAllGet', 'version', version)
            const localVarPath = `/api/v{version}/CorporateEntity/all`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a list of all corporate entities
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionCorporateEntityIdAddressesGet: async (id: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionCorporateEntityIdAddressesGet', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionCorporateEntityIdAddressesGet', 'version', version)
            const localVarPath = `/api/v{version}/CorporateEntity/{id}/Addresses`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a CorporateEntity by id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionCorporateEntityIdDelete: async (id: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionCorporateEntityIdDelete', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionCorporateEntityIdDelete', 'version', version)
            const localVarPath = `/api/v{version}/CorporateEntity/{id}`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a CorporateEntity by Id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionCorporateEntityIdGet: async (id: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionCorporateEntityIdGet', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionCorporateEntityIdGet', 'version', version)
            const localVarPath = `/api/v{version}/CorporateEntity/{id}`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a New CorporateEntity.
         * @param {string} version 
         * @param {CreateCorporateEntityCommand} [createCorporateEntityCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionCorporateEntityPost: async (version: string, createCorporateEntityCommand?: CreateCorporateEntityCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionCorporateEntityPost', 'version', version)
            const localVarPath = `/api/v{version}/CorporateEntity`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCorporateEntityCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates a CorporateEntity
         * @param {string} version 
         * @param {UpdateCorporateEntityCommand} [updateCorporateEntityCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionCorporateEntityPut: async (version: string, updateCorporateEntityCommand?: UpdateCorporateEntityCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionCorporateEntityPut', 'version', version)
            const localVarPath = `/api/v{version}/CorporateEntity`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCorporateEntityCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Searches for CorporateEntity
         * @param {string} version 
         * @param {string} [term] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionCorporateEntitySearchGet: async (version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionCorporateEntitySearchGet', 'version', version)
            const localVarPath = `/api/v{version}/CorporateEntity/search`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (f) {
                localVarQueryParameter['f'] = f;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a list of all currencies
         * @param {string} version 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionCurrencyAllGet: async (version: string, pageNum?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionCurrencyAllGet', 'version', version)
            const localVarPath = `/api/v{version}/Currency/all`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a Currency by Id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionCurrencyIdGet: async (id: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionCurrencyIdGet', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionCurrencyIdGet', 'version', version)
            const localVarPath = `/api/v{version}/Currency/{id}`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a New Account Payable Invoice.
         * @param {string} version 
         * @param {CreateAccountPayableInvoice} [createAccountPayableInvoice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceAccountPayablePost: async (version: string, createAccountPayableInvoice?: CreateAccountPayableInvoice, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionInvoiceAccountPayablePost', 'version', version)
            const localVarPath = `/api/v{version}/Invoice/accountPayable`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAccountPayableInvoice, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceByJobIdJobIdGet: async (jobId: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('apiVversionInvoiceByJobIdJobIdGet', 'jobId', jobId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionInvoiceByJobIdJobIdGet', 'version', version)
            const localVarPath = `/api/v{version}/Invoice/byJobId/{jobId}`
                .replace(`{${"jobId"}}`, window.customEncodeURIComponent(jobId))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all invoice configurations for a specific corporate entity.  Optionally filter by country code.
         * @param {number} entityId The corporate entity ID
         * @param {string} version 
         * @param {string} [countryCode] Optional country code filter (2-letter ISO code)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceConfigurationEntityEntityIdGet: async (entityId: number, version: string, countryCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('apiVversionInvoiceConfigurationEntityEntityIdGet', 'entityId', entityId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionInvoiceConfigurationEntityEntityIdGet', 'version', version)
            const localVarPath = `/api/v{version}/InvoiceConfiguration/entity/{entityId}`
                .replace(`{${"entityId"}}`, window.customEncodeURIComponent(entityId))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (countryCode !== undefined) {
                localVarQueryParameter['countryCode'] = countryCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes (soft delete) an invoice configuration.
         * @param {number} id The configuration ID to delete
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceConfigurationIdDelete: async (id: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionInvoiceConfigurationIdDelete', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionInvoiceConfigurationIdDelete', 'version', version)
            const localVarPath = `/api/v{version}/InvoiceConfiguration/{id}`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing invoice configuration.
         * @param {number} id The configuration ID
         * @param {string} version 
         * @param {UpdateInvoiceConfigurationCommand} [updateInvoiceConfigurationCommand] The updated configuration details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceConfigurationIdPut: async (id: number, version: string, updateInvoiceConfigurationCommand?: UpdateInvoiceConfigurationCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionInvoiceConfigurationIdPut', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionInvoiceConfigurationIdPut', 'version', version)
            const localVarPath = `/api/v{version}/InvoiceConfiguration/{id}`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInvoiceConfigurationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a new invoice configuration for a corporate entity.
         * @param {string} version 
         * @param {CreateInvoiceConfigurationCommand} [createInvoiceConfigurationCommand] The configuration details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceConfigurationPost: async (version: string, createInvoiceConfigurationCommand?: CreateInvoiceConfigurationCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionInvoiceConfigurationPost', 'version', version)
            const localVarPath = `/api/v{version}/InvoiceConfiguration`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInvoiceConfigurationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a Invoice\'s attached file
         * @param {string} version 
         * @param {string} [fileURI] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceFileGet: async (version: string, fileURI?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionInvoiceFileGet', 'version', version)
            const localVarPath = `/api/v{version}/Invoice/file`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (fileURI !== undefined) {
                localVarQueryParameter['fileURI'] = fileURI;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a Invoice by id, including invoiceItems.
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceIdGet: async (id: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionInvoiceIdGet', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionInvoiceIdGet', 'version', version)
            const localVarPath = `/api/v{version}/Invoice/{id}`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Marks an invoice as moved to RDS in DynamoDB
         * @param {string} version 
         * @param {string} [jobId] The job ID of the invoice
         * @param {string} [tenantId] The tenant ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceMarkAsMovedToRDSPost: async (version: string, jobId?: string, tenantId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionInvoiceMarkAsMovedToRDSPost', 'version', version)
            const localVarPath = `/api/v{version}/Invoice/markAsMovedToRDS`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (jobId !== undefined) {
                localVarQueryParameter['jobId'] = jobId;
            }

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a New Invoice.
         * @param {string} version 
         * @param {CreateInvoiceCommand} [createInvoiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoicePost: async (version: string, createInvoiceCommand?: CreateInvoiceCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionInvoicePost', 'version', version)
            const localVarPath = `/api/v{version}/Invoice`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInvoiceCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing invoice, including invoiceItems.
         * @param {string} version 
         * @param {UpdateInvoiceCommand} [updateInvoiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoicePut: async (version: string, updateInvoiceCommand?: UpdateInvoiceCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionInvoicePut', 'version', version)
            const localVarPath = `/api/v{version}/Invoice`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInvoiceCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Searches for Invoices. If no date filters are passed, default to the last 60 days.
         * @param {string} version 
         * @param {string} [term] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceSearchGet: async (version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionInvoiceSearchGet', 'version', version)
            const localVarPath = `/api/v{version}/Invoice/search`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (f) {
                localVarQueryParameter['f'] = f;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Searches for issued Invoices. If no date filters or invoice numbers are passed, default to the last 60 days.
         * @param {string} version 
         * @param {number} [moduleId] 
         * @param {string} [term] 
         * @param {number} [pageSize] 
         * @param {string} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceSearchIncomingGet: async (version: string, moduleId?: number, term?: string, pageSize?: number, order?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionInvoiceSearchIncomingGet', 'version', version)
            const localVarPath = `/api/v{version}/Invoice/searchIncoming`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (moduleId !== undefined) {
                localVarQueryParameter['moduleId'] = moduleId;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Searches for issued Invoices. If no date filters or invoice numbers are passed, default to the last 60 days.
         * @param {string} version 
         * @param {string} [term] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceSearchIssuedGet: async (version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionInvoiceSearchIssuedGet', 'version', version)
            const localVarPath = `/api/v{version}/Invoice/searchIssued`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (f) {
                localVarQueryParameter['f'] = f;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get invoice types by id country
         * @param {number} idCountry 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceTypeCountryIdCountryGet: async (idCountry: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idCountry' is not null or undefined
            assertParamExists('apiVversionInvoiceTypeCountryIdCountryGet', 'idCountry', idCountry)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionInvoiceTypeCountryIdCountryGet', 'version', version)
            const localVarPath = `/api/v{version}/InvoiceType/Country/{idCountry}`
                .replace(`{${"idCountry"}}`, window.customEncodeURIComponent(idCountry))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Uploads an invoice to be processed
         * @param {string} version 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceUploadPost: async (version: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionInvoiceUploadPost', 'version', version)
            const localVarPath = `/api/v{version}/Invoice/upload`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Persona ListOptions
         * @param {string} version 
         * @param {number} [idEntityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionListPersonaListGet: async (version: string, idEntityType?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionListPersonaListGet', 'version', version)
            const localVarPath = `/api/v{version}/List/personaList`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idEntityType !== undefined) {
                localVarQueryParameter['idEntityType'] = idEntityType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Persona Types ListOptions
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionListPersonaTypeGet: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionListPersonaTypeGet', 'version', version)
            const localVarPath = `/api/v{version}/List/personaType`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the Persona that may be assigned to an email.
         * @param {string} email 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionPersonaEligibleInvoiceFromByEmailEmailGet: async (email: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('apiVversionPersonaEligibleInvoiceFromByEmailEmailGet', 'email', email)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionPersonaEligibleInvoiceFromByEmailEmailGet', 'version', version)
            const localVarPath = `/api/v{version}/Persona/EligibleInvoiceFrom/ByEmail/{email}`
                .replace(`{${"email"}}`, window.customEncodeURIComponent(email))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the Persona that I can create invoices from, based on the UserEntity header.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionPersonaEligibleInvoiceFromGet: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionPersonaEligibleInvoiceFromGet', 'version', version)
            const localVarPath = `/api/v{version}/Persona/EligibleInvoiceFrom`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the Persona that I can create invoices from, based on the UserEntity header with typeahead search.
         * @param {string} version 
         * @param {string} [term] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionPersonaEligibleInvoiceFromTypeAheadGet: async (version: string, term?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionPersonaEligibleInvoiceFromTypeAheadGet', 'version', version)
            const localVarPath = `/api/v{version}/Persona/EligibleInvoiceFromTypeAhead`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the Persona that I can create invoices from, based on the UserEntity header.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionPersonaEligibleInvoiceToGet: async (version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionPersonaEligibleInvoiceToGet', 'version', version)
            const localVarPath = `/api/v{version}/Persona/EligibleInvoiceTo`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the Personas that I can create invoices to, based on the UserEntity header with typeahead search.
         * @param {string} version 
         * @param {string} [term] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionPersonaEligibleInvoiceToTypeAheadGet: async (version: string, term?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionPersonaEligibleInvoiceToTypeAheadGet', 'version', version)
            const localVarPath = `/api/v{version}/Persona/EligibleInvoiceToTypeAhead`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a Persona by EntityId
         * @param {number} entityId 
         * @param {string} version 
         * @param {number} [idEntityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionPersonaEntityIdEntityIdGet: async (entityId: number, version: string, idEntityType?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('apiVversionPersonaEntityIdEntityIdGet', 'entityId', entityId)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionPersonaEntityIdEntityIdGet', 'version', version)
            const localVarPath = `/api/v{version}/Persona/EntityId/{entityId}`
                .replace(`{${"entityId"}}`, window.customEncodeURIComponent(entityId))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (idEntityType !== undefined) {
                localVarQueryParameter['idEntityType'] = idEntityType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes a Persona by id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionPersonaIdDelete: async (id: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionPersonaIdDelete', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionPersonaIdDelete', 'version', version)
            const localVarPath = `/api/v{version}/Persona/{id}`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a Persona by Id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionPersonaIdGet: async (id: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionPersonaIdGet', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionPersonaIdGet', 'version', version)
            const localVarPath = `/api/v{version}/Persona/{id}`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a list of Personas by Entity Type with typeahead search.
         * @param {string} version 
         * @param {Array<number>} [entityTypes] 
         * @param {string} [term] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionPersonaPersonasByEntityTypeTypeAheadGet: async (version: string, entityTypes?: Array<number>, term?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionPersonaPersonasByEntityTypeTypeAheadGet', 'version', version)
            const localVarPath = `/api/v{version}/Persona/personasByEntityTypeTypeAhead`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (entityTypes) {
                localVarQueryParameter['entityTypes'] = entityTypes;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a list of Personas by Entity Types
         * @param {string} version 
         * @param {Array<number>} [entityTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionPersonaPersonasByEntityTypesGet: async (version: string, entityTypes?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionPersonaPersonasByEntityTypesGet', 'version', version)
            const localVarPath = `/api/v{version}/Persona/personasByEntityTypes`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (entityTypes) {
                localVarQueryParameter['entityTypes'] = entityTypes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a New Persona
         * @param {string} version 
         * @param {CreatePersonaCommand} [createPersonaCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionPersonaPost: async (version: string, createPersonaCommand?: CreatePersonaCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionPersonaPost', 'version', version)
            const localVarPath = `/api/v{version}/Persona`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPersonaCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an existing Persona
         * @param {string} version 
         * @param {UpdatePersonaCommand} [updatePersonaCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionPersonaPut: async (version: string, updatePersonaCommand?: UpdatePersonaCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionPersonaPut', 'version', version)
            const localVarPath = `/api/v{version}/Persona`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePersonaCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get TaxRates by country id, including invoiceItems.
         * @param {number} id 
         * @param {string} version 
         * @param {number} [applyTo] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTaxRateCountryIdGet: async (id: number, version: string, applyTo?: number, pageNum?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionTaxRateCountryIdGet', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTaxRateCountryIdGet', 'version', version)
            const localVarPath = `/api/v{version}/TaxRate/country/{id}`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (applyTo !== undefined) {
                localVarQueryParameter['applyTo'] = applyTo;
            }

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get TaxRates by country id with typeahead search.
         * @param {number} id 
         * @param {string} version 
         * @param {number} [applyTo] 
         * @param {string} [term] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTaxRateCountryIdTypeaheadGet: async (id: number, version: string, applyTo?: number, term?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionTaxRateCountryIdTypeaheadGet', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTaxRateCountryIdTypeaheadGet', 'version', version)
            const localVarPath = `/api/v{version}/TaxRate/country/{id}/typeahead`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (applyTo !== undefined) {
                localVarQueryParameter['applyTo'] = applyTo;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all TaxRates with pagination, sorting, and filtering.
         * @param {string} version 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {string} [name] Filter by tax rate name (partial match)
         * @param {number} [countryId] Filter by country ID
         * @param {number} [appliesTo] Filter by applies to value (0&#x3D;All, 1&#x3D;Item, 2&#x3D;Invoice)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTaxRateGet: async (version: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, name?: string, countryId?: number, appliesTo?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTaxRateGet', 'version', version)
            const localVarPath = `/api/v{version}/TaxRate`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNum !== undefined) {
                localVarQueryParameter['pageNum'] = pageNum;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (countryId !== undefined) {
                localVarQueryParameter['countryId'] = countryId;
            }

            if (appliesTo !== undefined) {
                localVarQueryParameter['appliesTo'] = appliesTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete (soft delete) a TaxRate.
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTaxRateIdDelete: async (id: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionTaxRateIdDelete', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTaxRateIdDelete', 'version', version)
            const localVarPath = `/api/v{version}/TaxRate/{id}`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get TaxRate by id.
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTaxRateIdGet: async (id: number, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionTaxRateIdGet', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTaxRateIdGet', 'version', version)
            const localVarPath = `/api/v{version}/TaxRate/{id}`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing TaxRate.
         * @param {number} id 
         * @param {string} version 
         * @param {UpdateTaxRateCommand} [updateTaxRateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTaxRateIdPut: async (id: number, version: string, updateTaxRateCommand?: UpdateTaxRateCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVversionTaxRateIdPut', 'id', id)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTaxRateIdPut', 'version', version)
            const localVarPath = `/api/v{version}/TaxRate/{id}`
                .replace(`{${"id"}}`, window.customEncodeURIComponent(id))
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTaxRateCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new TaxRate.
         * @param {string} version 
         * @param {CreateTaxRateCommand} [createTaxRateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTaxRatePost: async (version: string, createTaxRateCommand?: CreateTaxRateCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'version' is not null or undefined
            assertParamExists('apiVversionTaxRatePost', 'version', version)
            const localVarPath = `/api/v{version}/TaxRate`
                .replace(`{${"version"}}`, window.customEncodeURIComponent(version));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Userentity required
            await setApiKeyToObject(localVarHeaderParameter, "Userentity", configuration)

            // authentication Referer required
            

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTaxRateCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoiceApi - functional programming interface
 * @export
 */
export const InvoiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets a list of all corporate entities
         * @param {string} version 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionCorporateEntityAllGet(version: string, pageNum?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorporateEntitySearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionCorporateEntityAllGet(version, pageNum, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionCorporateEntityAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a list of all corporate entities
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionCorporateEntityIdAddressesGet(id: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddressSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionCorporateEntityIdAddressesGet(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionCorporateEntityIdAddressesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes a CorporateEntity by id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionCorporateEntityIdDelete(id: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionCorporateEntityIdDelete(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionCorporateEntityIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a CorporateEntity by Id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionCorporateEntityIdGet(id: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorporateEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionCorporateEntityIdGet(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionCorporateEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a New CorporateEntity.
         * @param {string} version 
         * @param {CreateCorporateEntityCommand} [createCorporateEntityCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionCorporateEntityPost(version: string, createCorporateEntityCommand?: CreateCorporateEntityCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorporateEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionCorporateEntityPost(version, createCorporateEntityCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionCorporateEntityPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates a CorporateEntity
         * @param {string} version 
         * @param {UpdateCorporateEntityCommand} [updateCorporateEntityCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionCorporateEntityPut(version: string, updateCorporateEntityCommand?: UpdateCorporateEntityCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorporateEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionCorporateEntityPut(version, updateCorporateEntityCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionCorporateEntityPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Searches for CorporateEntity
         * @param {string} version 
         * @param {string} [term] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionCorporateEntitySearchGet(version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorporateEntitySearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionCorporateEntitySearchGet(version, term, pageNum, pageSize, sort, order, f, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionCorporateEntitySearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a list of all currencies
         * @param {string} version 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionCurrencyAllGet(version: string, pageNum?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrencySearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionCurrencyAllGet(version, pageNum, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionCurrencyAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a Currency by Id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionCurrencyIdGet(id: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrencyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionCurrencyIdGet(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionCurrencyIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a New Account Payable Invoice.
         * @param {string} version 
         * @param {CreateAccountPayableInvoice} [createAccountPayableInvoice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionInvoiceAccountPayablePost(version: string, createAccountPayableInvoice?: CreateAccountPayableInvoice, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionInvoiceAccountPayablePost(version, createAccountPayableInvoice, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionInvoiceAccountPayablePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionInvoiceByJobIdJobIdGet(jobId: string, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IncomingInvoiceDTOSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionInvoiceByJobIdJobIdGet(jobId, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionInvoiceByJobIdJobIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets all invoice configurations for a specific corporate entity.  Optionally filter by country code.
         * @param {number} entityId The corporate entity ID
         * @param {string} version 
         * @param {string} [countryCode] Optional country code filter (2-letter ISO code)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionInvoiceConfigurationEntityEntityIdGet(entityId: number, version: string, countryCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorporateEntityInvoiceConfigurationDTOListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionInvoiceConfigurationEntityEntityIdGet(entityId, version, countryCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionInvoiceConfigurationEntityEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes (soft delete) an invoice configuration.
         * @param {number} id The configuration ID to delete
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionInvoiceConfigurationIdDelete(id: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionInvoiceConfigurationIdDelete(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionInvoiceConfigurationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates an existing invoice configuration.
         * @param {number} id The configuration ID
         * @param {string} version 
         * @param {UpdateInvoiceConfigurationCommand} [updateInvoiceConfigurationCommand] The updated configuration details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionInvoiceConfigurationIdPut(id: number, version: string, updateInvoiceConfigurationCommand?: UpdateInvoiceConfigurationCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorporateEntityInvoiceConfigurationDTOResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionInvoiceConfigurationIdPut(id, version, updateInvoiceConfigurationCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionInvoiceConfigurationIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a new invoice configuration for a corporate entity.
         * @param {string} version 
         * @param {CreateInvoiceConfigurationCommand} [createInvoiceConfigurationCommand] The configuration details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionInvoiceConfigurationPost(version: string, createInvoiceConfigurationCommand?: CreateInvoiceConfigurationCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CorporateEntityInvoiceConfigurationDTOResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionInvoiceConfigurationPost(version, createInvoiceConfigurationCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionInvoiceConfigurationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a Invoice\'s attached file
         * @param {string} version 
         * @param {string} [fileURI] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionInvoiceFileGet(version: string, fileURI?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringStringDictionaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionInvoiceFileGet(version, fileURI, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionInvoiceFileGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a Invoice by id, including invoiceItems.
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionInvoiceIdGet(id: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionInvoiceIdGet(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionInvoiceIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Marks an invoice as moved to RDS in DynamoDB
         * @param {string} version 
         * @param {string} [jobId] The job ID of the invoice
         * @param {string} [tenantId] The tenant ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionInvoiceMarkAsMovedToRDSPost(version: string, jobId?: string, tenantId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionInvoiceMarkAsMovedToRDSPost(version, jobId, tenantId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionInvoiceMarkAsMovedToRDSPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a New Invoice.
         * @param {string} version 
         * @param {CreateInvoiceCommand} [createInvoiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionInvoicePost(version: string, createInvoiceCommand?: CreateInvoiceCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionInvoicePost(version, createInvoiceCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionInvoicePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates an existing invoice, including invoiceItems.
         * @param {string} version 
         * @param {UpdateInvoiceCommand} [updateInvoiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionInvoicePut(version: string, updateInvoiceCommand?: UpdateInvoiceCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionInvoicePut(version, updateInvoiceCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionInvoicePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Searches for Invoices. If no date filters are passed, default to the last 60 days.
         * @param {string} version 
         * @param {string} [term] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionInvoiceSearchGet(version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionInvoiceSearchGet(version, term, pageNum, pageSize, sort, order, f, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionInvoiceSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Searches for issued Invoices. If no date filters or invoice numbers are passed, default to the last 60 days.
         * @param {string} version 
         * @param {number} [moduleId] 
         * @param {string} [term] 
         * @param {number} [pageSize] 
         * @param {string} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionInvoiceSearchIncomingGet(version: string, moduleId?: number, term?: string, pageSize?: number, order?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IncomingInvoiceDTOSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionInvoiceSearchIncomingGet(version, moduleId, term, pageSize, order, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionInvoiceSearchIncomingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Searches for issued Invoices. If no date filters or invoice numbers are passed, default to the last 60 days.
         * @param {string} version 
         * @param {string} [term] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionInvoiceSearchIssuedGet(version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionInvoiceSearchIssuedGet(version, term, pageNum, pageSize, sort, order, f, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionInvoiceSearchIssuedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get invoice types by id country
         * @param {number} idCountry 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionInvoiceTypeCountryIdCountryGet(idCountry: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceTypeSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionInvoiceTypeCountryIdCountryGet(idCountry, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionInvoiceTypeCountryIdCountryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Uploads an invoice to be processed
         * @param {string} version 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionInvoiceUploadPost(version: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionInvoiceUploadPost(version, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionInvoiceUploadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Persona ListOptions
         * @param {string} version 
         * @param {number} [idEntityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionListPersonaListGet(version: string, idEntityType?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListOptionDTOSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionListPersonaListGet(version, idEntityType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionListPersonaListGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Persona Types ListOptions
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionListPersonaTypeGet(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListOptionDTOSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionListPersonaTypeGet(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionListPersonaTypeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the Persona that may be assigned to an email.
         * @param {string} email 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionPersonaEligibleInvoiceFromByEmailEmailGet(email: string, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonaSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionPersonaEligibleInvoiceFromByEmailEmailGet(email, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionPersonaEligibleInvoiceFromByEmailEmailGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the Persona that I can create invoices from, based on the UserEntity header.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionPersonaEligibleInvoiceFromGet(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionPersonaEligibleInvoiceFromGet(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionPersonaEligibleInvoiceFromGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the Persona that I can create invoices from, based on the UserEntity header with typeahead search.
         * @param {string} version 
         * @param {string} [term] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionPersonaEligibleInvoiceFromTypeAheadGet(version: string, term?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonaSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionPersonaEligibleInvoiceFromTypeAheadGet(version, term, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionPersonaEligibleInvoiceFromTypeAheadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the Persona that I can create invoices from, based on the UserEntity header.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionPersonaEligibleInvoiceToGet(version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonaSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionPersonaEligibleInvoiceToGet(version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionPersonaEligibleInvoiceToGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the Personas that I can create invoices to, based on the UserEntity header with typeahead search.
         * @param {string} version 
         * @param {string} [term] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionPersonaEligibleInvoiceToTypeAheadGet(version: string, term?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonaSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionPersonaEligibleInvoiceToTypeAheadGet(version, term, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionPersonaEligibleInvoiceToTypeAheadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a Persona by EntityId
         * @param {number} entityId 
         * @param {string} version 
         * @param {number} [idEntityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionPersonaEntityIdEntityIdGet(entityId: number, version: string, idEntityType?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionPersonaEntityIdEntityIdGet(entityId, version, idEntityType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionPersonaEntityIdEntityIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Deletes a Persona by id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionPersonaIdDelete(id: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusCodeResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionPersonaIdDelete(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionPersonaIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a Persona by Id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionPersonaIdGet(id: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionPersonaIdGet(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionPersonaIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a list of Personas by Entity Type with typeahead search.
         * @param {string} version 
         * @param {Array<number>} [entityTypes] 
         * @param {string} [term] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionPersonaPersonasByEntityTypeTypeAheadGet(version: string, entityTypes?: Array<number>, term?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonaSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionPersonaPersonasByEntityTypeTypeAheadGet(version, entityTypes, term, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionPersonaPersonasByEntityTypeTypeAheadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a list of Personas by Entity Types
         * @param {string} version 
         * @param {Array<number>} [entityTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionPersonaPersonasByEntityTypesGet(version: string, entityTypes?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonaSearchResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionPersonaPersonasByEntityTypesGet(version, entityTypes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionPersonaPersonasByEntityTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a New Persona
         * @param {string} version 
         * @param {CreatePersonaCommand} [createPersonaCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionPersonaPost(version: string, createPersonaCommand?: CreatePersonaCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionPersonaPost(version, createPersonaCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionPersonaPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates an existing Persona
         * @param {string} version 
         * @param {UpdatePersonaCommand} [updatePersonaCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionPersonaPut(version: string, updatePersonaCommand?: UpdatePersonaCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionPersonaPut(version, updatePersonaCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionPersonaPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get TaxRates by country id, including invoiceItems.
         * @param {number} id 
         * @param {string} version 
         * @param {number} [applyTo] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTaxRateCountryIdGet(id: number, version: string, applyTo?: number, pageNum?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxRateSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTaxRateCountryIdGet(id, version, applyTo, pageNum, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionTaxRateCountryIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get TaxRates by country id with typeahead search.
         * @param {number} id 
         * @param {string} version 
         * @param {number} [applyTo] 
         * @param {string} [term] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTaxRateCountryIdTypeaheadGet(id: number, version: string, applyTo?: number, term?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxRateSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTaxRateCountryIdTypeaheadGet(id, version, applyTo, term, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionTaxRateCountryIdTypeaheadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all TaxRates with pagination, sorting, and filtering.
         * @param {string} version 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {string} [name] Filter by tax rate name (partial match)
         * @param {number} [countryId] Filter by country ID
         * @param {number} [appliesTo] Filter by applies to value (0&#x3D;All, 1&#x3D;Item, 2&#x3D;Invoice)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTaxRateGet(version: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, name?: string, countryId?: number, appliesTo?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxRateSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTaxRateGet(version, pageNum, pageSize, sort, order, name, countryId, appliesTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionTaxRateGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete (soft delete) a TaxRate.
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTaxRateIdDelete(id: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTaxRateIdDelete(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionTaxRateIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get TaxRate by id.
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTaxRateIdGet(id: number, version: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxRateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTaxRateIdGet(id, version, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionTaxRateIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing TaxRate.
         * @param {number} id 
         * @param {string} version 
         * @param {UpdateTaxRateCommand} [updateTaxRateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTaxRateIdPut(id: number, version: string, updateTaxRateCommand?: UpdateTaxRateCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxRateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTaxRateIdPut(id, version, updateTaxRateCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionTaxRateIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new TaxRate.
         * @param {string} version 
         * @param {CreateTaxRateCommand} [createTaxRateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVversionTaxRatePost(version: string, createTaxRateCommand?: CreateTaxRateCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxRateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVversionTaxRatePost(version, createTaxRateCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.apiVversionTaxRatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvoiceApi - factory interface
 * @export
 */
export const InvoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoiceApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets a list of all corporate entities
         * @param {string} version 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionCorporateEntityAllGet(version: string, pageNum?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<CorporateEntitySearchResponseResponse> {
            return localVarFp.apiVversionCorporateEntityAllGet(version, pageNum, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a list of all corporate entities
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionCorporateEntityIdAddressesGet(id: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<AddressSearchResponseResponse> {
            return localVarFp.apiVversionCorporateEntityIdAddressesGet(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a CorporateEntity by id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionCorporateEntityIdDelete(id: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<BooleanResponse> {
            return localVarFp.apiVversionCorporateEntityIdDelete(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a CorporateEntity by Id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionCorporateEntityIdGet(id: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<CorporateEntityResponse> {
            return localVarFp.apiVversionCorporateEntityIdGet(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a New CorporateEntity.
         * @param {string} version 
         * @param {CreateCorporateEntityCommand} [createCorporateEntityCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionCorporateEntityPost(version: string, createCorporateEntityCommand?: CreateCorporateEntityCommand, options?: RawAxiosRequestConfig): AxiosPromise<CorporateEntityResponse> {
            return localVarFp.apiVversionCorporateEntityPost(version, createCorporateEntityCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates a CorporateEntity
         * @param {string} version 
         * @param {UpdateCorporateEntityCommand} [updateCorporateEntityCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionCorporateEntityPut(version: string, updateCorporateEntityCommand?: UpdateCorporateEntityCommand, options?: RawAxiosRequestConfig): AxiosPromise<CorporateEntityResponse> {
            return localVarFp.apiVversionCorporateEntityPut(version, updateCorporateEntityCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Searches for CorporateEntity
         * @param {string} version 
         * @param {string} [term] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionCorporateEntitySearchGet(version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<CorporateEntitySearchResponseResponse> {
            return localVarFp.apiVversionCorporateEntitySearchGet(version, term, pageNum, pageSize, sort, order, f, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a list of all currencies
         * @param {string} version 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionCurrencyAllGet(version: string, pageNum?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<CurrencySearchResponseResponse> {
            return localVarFp.apiVversionCurrencyAllGet(version, pageNum, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a Currency by Id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionCurrencyIdGet(id: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<CurrencyResponse> {
            return localVarFp.apiVversionCurrencyIdGet(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a New Account Payable Invoice.
         * @param {string} version 
         * @param {CreateAccountPayableInvoice} [createAccountPayableInvoice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceAccountPayablePost(version: string, createAccountPayableInvoice?: CreateAccountPayableInvoice, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceResponse> {
            return localVarFp.apiVversionInvoiceAccountPayablePost(version, createAccountPayableInvoice, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} jobId 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceByJobIdJobIdGet(jobId: string, version: string, options?: RawAxiosRequestConfig): AxiosPromise<IncomingInvoiceDTOSearchResponseResponse> {
            return localVarFp.apiVversionInvoiceByJobIdJobIdGet(jobId, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all invoice configurations for a specific corporate entity.  Optionally filter by country code.
         * @param {number} entityId The corporate entity ID
         * @param {string} version 
         * @param {string} [countryCode] Optional country code filter (2-letter ISO code)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceConfigurationEntityEntityIdGet(entityId: number, version: string, countryCode?: string, options?: RawAxiosRequestConfig): AxiosPromise<CorporateEntityInvoiceConfigurationDTOListResponse> {
            return localVarFp.apiVversionInvoiceConfigurationEntityEntityIdGet(entityId, version, countryCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes (soft delete) an invoice configuration.
         * @param {number} id The configuration ID to delete
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceConfigurationIdDelete(id: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<BooleanResponse> {
            return localVarFp.apiVversionInvoiceConfigurationIdDelete(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing invoice configuration.
         * @param {number} id The configuration ID
         * @param {string} version 
         * @param {UpdateInvoiceConfigurationCommand} [updateInvoiceConfigurationCommand] The updated configuration details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceConfigurationIdPut(id: number, version: string, updateInvoiceConfigurationCommand?: UpdateInvoiceConfigurationCommand, options?: RawAxiosRequestConfig): AxiosPromise<CorporateEntityInvoiceConfigurationDTOResponse> {
            return localVarFp.apiVversionInvoiceConfigurationIdPut(id, version, updateInvoiceConfigurationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a new invoice configuration for a corporate entity.
         * @param {string} version 
         * @param {CreateInvoiceConfigurationCommand} [createInvoiceConfigurationCommand] The configuration details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceConfigurationPost(version: string, createInvoiceConfigurationCommand?: CreateInvoiceConfigurationCommand, options?: RawAxiosRequestConfig): AxiosPromise<CorporateEntityInvoiceConfigurationDTOResponse> {
            return localVarFp.apiVversionInvoiceConfigurationPost(version, createInvoiceConfigurationCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a Invoice\'s attached file
         * @param {string} version 
         * @param {string} [fileURI] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceFileGet(version: string, fileURI?: string, options?: RawAxiosRequestConfig): AxiosPromise<StringStringDictionaryResponse> {
            return localVarFp.apiVversionInvoiceFileGet(version, fileURI, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a Invoice by id, including invoiceItems.
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceIdGet(id: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceResponse> {
            return localVarFp.apiVversionInvoiceIdGet(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marks an invoice as moved to RDS in DynamoDB
         * @param {string} version 
         * @param {string} [jobId] The job ID of the invoice
         * @param {string} [tenantId] The tenant ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceMarkAsMovedToRDSPost(version: string, jobId?: string, tenantId?: string, options?: RawAxiosRequestConfig): AxiosPromise<BooleanResponse> {
            return localVarFp.apiVversionInvoiceMarkAsMovedToRDSPost(version, jobId, tenantId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a New Invoice.
         * @param {string} version 
         * @param {CreateInvoiceCommand} [createInvoiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoicePost(version: string, createInvoiceCommand?: CreateInvoiceCommand, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceResponse> {
            return localVarFp.apiVversionInvoicePost(version, createInvoiceCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing invoice, including invoiceItems.
         * @param {string} version 
         * @param {UpdateInvoiceCommand} [updateInvoiceCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoicePut(version: string, updateInvoiceCommand?: UpdateInvoiceCommand, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceResponse> {
            return localVarFp.apiVversionInvoicePut(version, updateInvoiceCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Searches for Invoices. If no date filters are passed, default to the last 60 days.
         * @param {string} version 
         * @param {string} [term] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceSearchGet(version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceSearchResponseResponse> {
            return localVarFp.apiVversionInvoiceSearchGet(version, term, pageNum, pageSize, sort, order, f, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Searches for issued Invoices. If no date filters or invoice numbers are passed, default to the last 60 days.
         * @param {string} version 
         * @param {number} [moduleId] 
         * @param {string} [term] 
         * @param {number} [pageSize] 
         * @param {string} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceSearchIncomingGet(version: string, moduleId?: number, term?: string, pageSize?: number, order?: string, options?: RawAxiosRequestConfig): AxiosPromise<IncomingInvoiceDTOSearchResponseResponse> {
            return localVarFp.apiVversionInvoiceSearchIncomingGet(version, moduleId, term, pageSize, order, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Searches for issued Invoices. If no date filters or invoice numbers are passed, default to the last 60 days.
         * @param {string} version 
         * @param {string} [term] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {Array<string>} [f] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceSearchIssuedGet(version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceSearchResponseResponse> {
            return localVarFp.apiVversionInvoiceSearchIssuedGet(version, term, pageNum, pageSize, sort, order, f, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get invoice types by id country
         * @param {number} idCountry 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceTypeCountryIdCountryGet(idCountry: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<InvoiceTypeSearchResponseResponse> {
            return localVarFp.apiVversionInvoiceTypeCountryIdCountryGet(idCountry, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Uploads an invoice to be processed
         * @param {string} version 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionInvoiceUploadPost(version: string, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<StringResponse> {
            return localVarFp.apiVversionInvoiceUploadPost(version, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Persona ListOptions
         * @param {string} version 
         * @param {number} [idEntityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionListPersonaListGet(version: string, idEntityType?: number, options?: RawAxiosRequestConfig): AxiosPromise<ListOptionDTOSearchResponseResponse> {
            return localVarFp.apiVversionListPersonaListGet(version, idEntityType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Persona Types ListOptions
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionListPersonaTypeGet(version: string, options?: RawAxiosRequestConfig): AxiosPromise<ListOptionDTOSearchResponseResponse> {
            return localVarFp.apiVversionListPersonaTypeGet(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the Persona that may be assigned to an email.
         * @param {string} email 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionPersonaEligibleInvoiceFromByEmailEmailGet(email: string, version: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonaSearchResponseResponse> {
            return localVarFp.apiVversionPersonaEligibleInvoiceFromByEmailEmailGet(email, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the Persona that I can create invoices from, based on the UserEntity header.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionPersonaEligibleInvoiceFromGet(version: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonaResponse> {
            return localVarFp.apiVversionPersonaEligibleInvoiceFromGet(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the Persona that I can create invoices from, based on the UserEntity header with typeahead search.
         * @param {string} version 
         * @param {string} [term] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionPersonaEligibleInvoiceFromTypeAheadGet(version: string, term?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonaSearchResponseResponse> {
            return localVarFp.apiVversionPersonaEligibleInvoiceFromTypeAheadGet(version, term, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the Persona that I can create invoices from, based on the UserEntity header.
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionPersonaEligibleInvoiceToGet(version: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonaSearchResponseResponse> {
            return localVarFp.apiVversionPersonaEligibleInvoiceToGet(version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the Personas that I can create invoices to, based on the UserEntity header with typeahead search.
         * @param {string} version 
         * @param {string} [term] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionPersonaEligibleInvoiceToTypeAheadGet(version: string, term?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonaSearchResponseResponse> {
            return localVarFp.apiVversionPersonaEligibleInvoiceToTypeAheadGet(version, term, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a Persona by EntityId
         * @param {number} entityId 
         * @param {string} version 
         * @param {number} [idEntityType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionPersonaEntityIdEntityIdGet(entityId: number, version: string, idEntityType?: number, options?: RawAxiosRequestConfig): AxiosPromise<PersonaResponse> {
            return localVarFp.apiVversionPersonaEntityIdEntityIdGet(entityId, version, idEntityType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deletes a Persona by id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionPersonaIdDelete(id: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<StatusCodeResult> {
            return localVarFp.apiVversionPersonaIdDelete(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a Persona by Id
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionPersonaIdGet(id: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonaResponse> {
            return localVarFp.apiVversionPersonaIdGet(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a list of Personas by Entity Type with typeahead search.
         * @param {string} version 
         * @param {Array<number>} [entityTypes] 
         * @param {string} [term] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionPersonaPersonasByEntityTypeTypeAheadGet(version: string, entityTypes?: Array<number>, term?: string, options?: RawAxiosRequestConfig): AxiosPromise<PersonaSearchResponseResponse> {
            return localVarFp.apiVversionPersonaPersonasByEntityTypeTypeAheadGet(version, entityTypes, term, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a list of Personas by Entity Types
         * @param {string} version 
         * @param {Array<number>} [entityTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionPersonaPersonasByEntityTypesGet(version: string, entityTypes?: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<PersonaSearchResponseResponse> {
            return localVarFp.apiVversionPersonaPersonasByEntityTypesGet(version, entityTypes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a New Persona
         * @param {string} version 
         * @param {CreatePersonaCommand} [createPersonaCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionPersonaPost(version: string, createPersonaCommand?: CreatePersonaCommand, options?: RawAxiosRequestConfig): AxiosPromise<PersonaResponse> {
            return localVarFp.apiVversionPersonaPost(version, createPersonaCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an existing Persona
         * @param {string} version 
         * @param {UpdatePersonaCommand} [updatePersonaCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionPersonaPut(version: string, updatePersonaCommand?: UpdatePersonaCommand, options?: RawAxiosRequestConfig): AxiosPromise<PersonaResponse> {
            return localVarFp.apiVversionPersonaPut(version, updatePersonaCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get TaxRates by country id, including invoiceItems.
         * @param {number} id 
         * @param {string} version 
         * @param {number} [applyTo] 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTaxRateCountryIdGet(id: number, version: string, applyTo?: number, pageNum?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<TaxRateSearchResponse> {
            return localVarFp.apiVversionTaxRateCountryIdGet(id, version, applyTo, pageNum, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get TaxRates by country id with typeahead search.
         * @param {number} id 
         * @param {string} version 
         * @param {number} [applyTo] 
         * @param {string} [term] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTaxRateCountryIdTypeaheadGet(id: number, version: string, applyTo?: number, term?: string, options?: RawAxiosRequestConfig): AxiosPromise<TaxRateSearchResponse> {
            return localVarFp.apiVversionTaxRateCountryIdTypeaheadGet(id, version, applyTo, term, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all TaxRates with pagination, sorting, and filtering.
         * @param {string} version 
         * @param {number} [pageNum] 
         * @param {number} [pageSize] 
         * @param {string} [sort] 
         * @param {string} [order] 
         * @param {string} [name] Filter by tax rate name (partial match)
         * @param {number} [countryId] Filter by country ID
         * @param {number} [appliesTo] Filter by applies to value (0&#x3D;All, 1&#x3D;Item, 2&#x3D;Invoice)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTaxRateGet(version: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, name?: string, countryId?: number, appliesTo?: number, options?: RawAxiosRequestConfig): AxiosPromise<TaxRateSearchResponse> {
            return localVarFp.apiVversionTaxRateGet(version, pageNum, pageSize, sort, order, name, countryId, appliesTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete (soft delete) a TaxRate.
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTaxRateIdDelete(id: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<BooleanResponse> {
            return localVarFp.apiVversionTaxRateIdDelete(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get TaxRate by id.
         * @param {number} id 
         * @param {string} version 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTaxRateIdGet(id: number, version: string, options?: RawAxiosRequestConfig): AxiosPromise<TaxRateResponse> {
            return localVarFp.apiVversionTaxRateIdGet(id, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing TaxRate.
         * @param {number} id 
         * @param {string} version 
         * @param {UpdateTaxRateCommand} [updateTaxRateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTaxRateIdPut(id: number, version: string, updateTaxRateCommand?: UpdateTaxRateCommand, options?: RawAxiosRequestConfig): AxiosPromise<TaxRateResponse> {
            return localVarFp.apiVversionTaxRateIdPut(id, version, updateTaxRateCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new TaxRate.
         * @param {string} version 
         * @param {CreateTaxRateCommand} [createTaxRateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVversionTaxRatePost(version: string, createTaxRateCommand?: CreateTaxRateCommand, options?: RawAxiosRequestConfig): AxiosPromise<TaxRateResponse> {
            return localVarFp.apiVversionTaxRatePost(version, createTaxRateCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvoiceApi - object-oriented interface
 * @export
 * @class InvoiceApi
 * @extends {BaseAPI}
 */
export class InvoiceApi extends BaseAPI {
    /**
     * 
     * @summary Gets a list of all corporate entities
     * @param {string} version 
     * @param {number} [pageNum] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionCorporateEntityAllGet(version: string, pageNum?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionCorporateEntityAllGet(version, pageNum, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a list of all corporate entities
     * @param {number} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionCorporateEntityIdAddressesGet(id: number, version: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionCorporateEntityIdAddressesGet(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a CorporateEntity by id
     * @param {number} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionCorporateEntityIdDelete(id: number, version: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionCorporateEntityIdDelete(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a CorporateEntity by Id
     * @param {number} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionCorporateEntityIdGet(id: number, version: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionCorporateEntityIdGet(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a New CorporateEntity.
     * @param {string} version 
     * @param {CreateCorporateEntityCommand} [createCorporateEntityCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionCorporateEntityPost(version: string, createCorporateEntityCommand?: CreateCorporateEntityCommand, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionCorporateEntityPost(version, createCorporateEntityCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates a CorporateEntity
     * @param {string} version 
     * @param {UpdateCorporateEntityCommand} [updateCorporateEntityCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionCorporateEntityPut(version: string, updateCorporateEntityCommand?: UpdateCorporateEntityCommand, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionCorporateEntityPut(version, updateCorporateEntityCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Searches for CorporateEntity
     * @param {string} version 
     * @param {string} [term] 
     * @param {number} [pageNum] 
     * @param {number} [pageSize] 
     * @param {string} [sort] 
     * @param {string} [order] 
     * @param {Array<string>} [f] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionCorporateEntitySearchGet(version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionCorporateEntitySearchGet(version, term, pageNum, pageSize, sort, order, f, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a list of all currencies
     * @param {string} version 
     * @param {number} [pageNum] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionCurrencyAllGet(version: string, pageNum?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionCurrencyAllGet(version, pageNum, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a Currency by Id
     * @param {number} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionCurrencyIdGet(id: number, version: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionCurrencyIdGet(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a New Account Payable Invoice.
     * @param {string} version 
     * @param {CreateAccountPayableInvoice} [createAccountPayableInvoice] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionInvoiceAccountPayablePost(version: string, createAccountPayableInvoice?: CreateAccountPayableInvoice, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionInvoiceAccountPayablePost(version, createAccountPayableInvoice, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} jobId 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionInvoiceByJobIdJobIdGet(jobId: string, version: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionInvoiceByJobIdJobIdGet(jobId, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all invoice configurations for a specific corporate entity.  Optionally filter by country code.
     * @param {number} entityId The corporate entity ID
     * @param {string} version 
     * @param {string} [countryCode] Optional country code filter (2-letter ISO code)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionInvoiceConfigurationEntityEntityIdGet(entityId: number, version: string, countryCode?: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionInvoiceConfigurationEntityEntityIdGet(entityId, version, countryCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes (soft delete) an invoice configuration.
     * @param {number} id The configuration ID to delete
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionInvoiceConfigurationIdDelete(id: number, version: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionInvoiceConfigurationIdDelete(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing invoice configuration.
     * @param {number} id The configuration ID
     * @param {string} version 
     * @param {UpdateInvoiceConfigurationCommand} [updateInvoiceConfigurationCommand] The updated configuration details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionInvoiceConfigurationIdPut(id: number, version: string, updateInvoiceConfigurationCommand?: UpdateInvoiceConfigurationCommand, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionInvoiceConfigurationIdPut(id, version, updateInvoiceConfigurationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a new invoice configuration for a corporate entity.
     * @param {string} version 
     * @param {CreateInvoiceConfigurationCommand} [createInvoiceConfigurationCommand] The configuration details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionInvoiceConfigurationPost(version: string, createInvoiceConfigurationCommand?: CreateInvoiceConfigurationCommand, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionInvoiceConfigurationPost(version, createInvoiceConfigurationCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a Invoice\'s attached file
     * @param {string} version 
     * @param {string} [fileURI] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionInvoiceFileGet(version: string, fileURI?: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionInvoiceFileGet(version, fileURI, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a Invoice by id, including invoiceItems.
     * @param {number} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionInvoiceIdGet(id: number, version: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionInvoiceIdGet(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marks an invoice as moved to RDS in DynamoDB
     * @param {string} version 
     * @param {string} [jobId] The job ID of the invoice
     * @param {string} [tenantId] The tenant ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionInvoiceMarkAsMovedToRDSPost(version: string, jobId?: string, tenantId?: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionInvoiceMarkAsMovedToRDSPost(version, jobId, tenantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a New Invoice.
     * @param {string} version 
     * @param {CreateInvoiceCommand} [createInvoiceCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionInvoicePost(version: string, createInvoiceCommand?: CreateInvoiceCommand, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionInvoicePost(version, createInvoiceCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing invoice, including invoiceItems.
     * @param {string} version 
     * @param {UpdateInvoiceCommand} [updateInvoiceCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionInvoicePut(version: string, updateInvoiceCommand?: UpdateInvoiceCommand, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionInvoicePut(version, updateInvoiceCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Searches for Invoices. If no date filters are passed, default to the last 60 days.
     * @param {string} version 
     * @param {string} [term] 
     * @param {number} [pageNum] 
     * @param {number} [pageSize] 
     * @param {string} [sort] 
     * @param {string} [order] 
     * @param {Array<string>} [f] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionInvoiceSearchGet(version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionInvoiceSearchGet(version, term, pageNum, pageSize, sort, order, f, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Searches for issued Invoices. If no date filters or invoice numbers are passed, default to the last 60 days.
     * @param {string} version 
     * @param {number} [moduleId] 
     * @param {string} [term] 
     * @param {number} [pageSize] 
     * @param {string} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionInvoiceSearchIncomingGet(version: string, moduleId?: number, term?: string, pageSize?: number, order?: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionInvoiceSearchIncomingGet(version, moduleId, term, pageSize, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Searches for issued Invoices. If no date filters or invoice numbers are passed, default to the last 60 days.
     * @param {string} version 
     * @param {string} [term] 
     * @param {number} [pageNum] 
     * @param {number} [pageSize] 
     * @param {string} [sort] 
     * @param {string} [order] 
     * @param {Array<string>} [f] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionInvoiceSearchIssuedGet(version: string, term?: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, f?: Array<string>, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionInvoiceSearchIssuedGet(version, term, pageNum, pageSize, sort, order, f, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get invoice types by id country
     * @param {number} idCountry 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionInvoiceTypeCountryIdCountryGet(idCountry: number, version: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionInvoiceTypeCountryIdCountryGet(idCountry, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Uploads an invoice to be processed
     * @param {string} version 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionInvoiceUploadPost(version: string, file?: File, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionInvoiceUploadPost(version, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Persona ListOptions
     * @param {string} version 
     * @param {number} [idEntityType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionListPersonaListGet(version: string, idEntityType?: number, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionListPersonaListGet(version, idEntityType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Persona Types ListOptions
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionListPersonaTypeGet(version: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionListPersonaTypeGet(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the Persona that may be assigned to an email.
     * @param {string} email 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionPersonaEligibleInvoiceFromByEmailEmailGet(email: string, version: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionPersonaEligibleInvoiceFromByEmailEmailGet(email, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the Persona that I can create invoices from, based on the UserEntity header.
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionPersonaEligibleInvoiceFromGet(version: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionPersonaEligibleInvoiceFromGet(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the Persona that I can create invoices from, based on the UserEntity header with typeahead search.
     * @param {string} version 
     * @param {string} [term] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionPersonaEligibleInvoiceFromTypeAheadGet(version: string, term?: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionPersonaEligibleInvoiceFromTypeAheadGet(version, term, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the Persona that I can create invoices from, based on the UserEntity header.
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionPersonaEligibleInvoiceToGet(version: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionPersonaEligibleInvoiceToGet(version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the Personas that I can create invoices to, based on the UserEntity header with typeahead search.
     * @param {string} version 
     * @param {string} [term] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionPersonaEligibleInvoiceToTypeAheadGet(version: string, term?: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionPersonaEligibleInvoiceToTypeAheadGet(version, term, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a Persona by EntityId
     * @param {number} entityId 
     * @param {string} version 
     * @param {number} [idEntityType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionPersonaEntityIdEntityIdGet(entityId: number, version: string, idEntityType?: number, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionPersonaEntityIdEntityIdGet(entityId, version, idEntityType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deletes a Persona by id
     * @param {number} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionPersonaIdDelete(id: number, version: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionPersonaIdDelete(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a Persona by Id
     * @param {number} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionPersonaIdGet(id: number, version: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionPersonaIdGet(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a list of Personas by Entity Type with typeahead search.
     * @param {string} version 
     * @param {Array<number>} [entityTypes] 
     * @param {string} [term] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionPersonaPersonasByEntityTypeTypeAheadGet(version: string, entityTypes?: Array<number>, term?: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionPersonaPersonasByEntityTypeTypeAheadGet(version, entityTypes, term, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a list of Personas by Entity Types
     * @param {string} version 
     * @param {Array<number>} [entityTypes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionPersonaPersonasByEntityTypesGet(version: string, entityTypes?: Array<number>, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionPersonaPersonasByEntityTypesGet(version, entityTypes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a New Persona
     * @param {string} version 
     * @param {CreatePersonaCommand} [createPersonaCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionPersonaPost(version: string, createPersonaCommand?: CreatePersonaCommand, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionPersonaPost(version, createPersonaCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates an existing Persona
     * @param {string} version 
     * @param {UpdatePersonaCommand} [updatePersonaCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionPersonaPut(version: string, updatePersonaCommand?: UpdatePersonaCommand, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionPersonaPut(version, updatePersonaCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get TaxRates by country id, including invoiceItems.
     * @param {number} id 
     * @param {string} version 
     * @param {number} [applyTo] 
     * @param {number} [pageNum] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionTaxRateCountryIdGet(id: number, version: string, applyTo?: number, pageNum?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionTaxRateCountryIdGet(id, version, applyTo, pageNum, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get TaxRates by country id with typeahead search.
     * @param {number} id 
     * @param {string} version 
     * @param {number} [applyTo] 
     * @param {string} [term] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionTaxRateCountryIdTypeaheadGet(id: number, version: string, applyTo?: number, term?: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionTaxRateCountryIdTypeaheadGet(id, version, applyTo, term, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all TaxRates with pagination, sorting, and filtering.
     * @param {string} version 
     * @param {number} [pageNum] 
     * @param {number} [pageSize] 
     * @param {string} [sort] 
     * @param {string} [order] 
     * @param {string} [name] Filter by tax rate name (partial match)
     * @param {number} [countryId] Filter by country ID
     * @param {number} [appliesTo] Filter by applies to value (0&#x3D;All, 1&#x3D;Item, 2&#x3D;Invoice)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionTaxRateGet(version: string, pageNum?: number, pageSize?: number, sort?: string, order?: string, name?: string, countryId?: number, appliesTo?: number, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionTaxRateGet(version, pageNum, pageSize, sort, order, name, countryId, appliesTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete (soft delete) a TaxRate.
     * @param {number} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionTaxRateIdDelete(id: number, version: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionTaxRateIdDelete(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get TaxRate by id.
     * @param {number} id 
     * @param {string} version 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionTaxRateIdGet(id: number, version: string, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionTaxRateIdGet(id, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing TaxRate.
     * @param {number} id 
     * @param {string} version 
     * @param {UpdateTaxRateCommand} [updateTaxRateCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionTaxRateIdPut(id: number, version: string, updateTaxRateCommand?: UpdateTaxRateCommand, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionTaxRateIdPut(id, version, updateTaxRateCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new TaxRate.
     * @param {string} version 
     * @param {CreateTaxRateCommand} [createTaxRateCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public apiVversionTaxRatePost(version: string, createTaxRateCommand?: CreateTaxRateCommand, options?: RawAxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).apiVversionTaxRatePost(version, createTaxRateCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

